"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      padding: theme.spacing(2)
    },
    icon: {
      color: 'inherit',
      fontSize: 'inherit',
      marginRight: theme.spacing(1)
    },
    avatar: {
      width: '46px',
      height: '46px',
      border: "4px solid ".concat(theme.palette.common.white),
      boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.1)',
      marginRight: theme.spacing(2),
      textTransform: 'uppercase',
      backgroundColor: function backgroundColor(_ref) {
        var _ref$backgroundColor = _ref.backgroundColor,
            _backgroundColor = _ref$backgroundColor === void 0 ? theme.palette.secondary.main : _ref$backgroundColor;

        return _backgroundColor;
      }
    },
    content: {
      marginTop: theme.spacing(1),
      wordBreak: 'break-word'
    },
    arrowIcon: {
      fontSize: 16,
      color: theme.palette.grey.main
    },
    showButton: {
      paddingTop: theme.spacing(1)
    }
  };
});

var EmailTemplateListItem = function EmailTemplateListItem(_ref2) {
  var template = _ref2.template,
      onSelect = _ref2.onSelect,
      divider = _ref2.divider;
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showSettings = _useState2[0],
      setShowSettings = _useState2[1];

  var avatarLetters = (0, _react.useMemo)(function () {
    return template.name.split(' ').map(function (item) {
      return item[0];
    }).join('').substring(0, 2);
  }, [template]);
  var linkButton = (0, _react.useMemo)(function () {
    return template.type !== 'sample' && /*#__PURE__*/_react.default.createElement(_ui.LinkButton, {
      className: (0, _classnames.default)('Body-Small-Link', classes.showButton),
      onClick: function onClick() {
        return setShowSettings(!showSettings);
      }
    }, showSettings ? 'Hide' : 'Show', " message");
  }, [template, classes, showSettings]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, divider && /*#__PURE__*/_react.default.createElement(_ui.Divider, {
    color: "divider"
  }), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "column",
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row",
    wrap: "nowrap",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_material.Avatar, {
    className: classes.avatar
  }, avatarLetters), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "column"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Medium-Link Text-Pointer",
    onClick: function onClick() {
      return onSelect(template);
    },
    "data-testid": template.name
  }, template.name), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: showSettings
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)('Body-Small-Static', classes.content)
  }, template.message)), linkButton), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    item: true,
    xs: 2,
    direction: "column",
    justifyContent: "center",
    alignItems: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    icon: "chevron-right",
    className: classes.arrowIcon
  })))));
};

EmailTemplateListItem.propTypes = {
  template: _propTypes.default.objectOf(_propTypes.default.string).isRequired,
  onSelect: _propTypes.default.func.isRequired,
  divider: _propTypes.default.bool
};
EmailTemplateListItem.defaultProps = {
  divider: false
};
var _default = EmailTemplateListItem;
exports.default = _default;